import { configureStore } from '@reduxjs/toolkit';
import titleSlice from './titleSlice';
import projectReducer from './projectSlice';
import selectedProjectReducer from './selectedProjectSlice';
import sidebarModeReducer from './sidebarModeSlice';
import sectionReducer from './sectionSlice';
import modelReducer from './modelSlice';
import repairIotReducer from './repairIotSlice'; // นำเข้า repairIotSlice
import calendarSlice from './calenderSlice'; // นำเข้า calendarSlice
import storageSession from 'redux-persist/lib/storage/session'; // ใช้ sessionStorage
import repairsGeneral from './repairGenaralSlice'; // นำเข้า repairGenaralSlice
import notificationReducer from "./notificationSlice";
import userReducer from './userSlice';
import { combineReducers } from 'redux';
import {
  persistStore,
  persistReducer,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER
} from 'redux-persist';

const persistConfig = {
  key: 'root',
  storage: storageSession,
  whitelist: ['title', 'selectedProject', 'user', 'projects'], // ← เพิ่ม projects ด้วย
  blacklist: ['notifications'],
};

const rootReducer = combineReducers({
  title: titleSlice,
  projects: projectReducer,
  selectedProject: selectedProjectReducer,
  sidebarMode: sidebarModeReducer,
  section: sectionReducer,
  models: modelReducer,
  repairsIot: repairIotReducer,
  calendar: calendarSlice,
  repairsGeneral: repairsGeneral,
  notifications: notificationReducer,
  user: userReducer, // ← เก็บ profile ไว้ไม่ให้ยิง API ซ้ำทุกครั้งเปลี่ยนหน้า
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        // ยกเว้น action พวกนี้จากการตรวจ serialize
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }),
});

export const persistor = persistStore(store);
export default store;
